<template>
    <div class="rich-text grid grid__base" :class="rootClasses">
        <div class="rich-text--content" v-if="isNested">
            <div v-html="body"/>
            <link-list v-if="links.length" :links="links"/>
        </div>
        <div class="grid--container" v-else>
            <div class="grid--row">
                <div class="rich-text--col grid--col" v-html="body"/>
            </div>
            <link-list v-if="links.length" :links="links"/>
        </div>
    </div>
</template>

<script>
    import LinkList from 'framework/components/link-list/link-list';
    import bemMixin from 'framework/mixins/bem';

    export default {
        components: { LinkList },
        mixins: [
            bemMixin('rich-text'),
        ],
        props: {
            body: {
                type: String,
                required: true,
            },
            /** @type {Array<ILink>} */
            links: {
                type: Array,
                default() {
                    return [];
                },
            },
            isNested: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            rootClasses() {
                return [
                    this.bemIf(this.isNested, 'is-nsted'),
                ];
            },
        },
    };
</script>
